import React from 'react'
import Popup from 'react-popup'
import intl from 'react-intl-universal'

class Multiselect extends React.Component {

    render() {
      const {question, elements, onChange} = this.props
      return (
        <div>
          <p>{question}</p><br/>
          <select
           multiple
           className="i-popup__select"
           onChange={onChange}>
            {elements.map((e)=><option key={e.id} value={e.id}>{e.name}</option>)}
          </select>
        </div>
      )
    }
}

Popup.registerPlugin('multiselect', function (question, elements, callback) {
    let selectedValue = []
    let onChange = function () {
      let opts = document.querySelector('.i-popup__select').selectedOptions
      selectedValue = [].slice.call(opts).map((o)=>parseInt(o.value))
    }

    this.create({
        content: <Multiselect
                  onChange={onChange}
                  elements={elements}
                  callback={callback}
                  question={question} />,
        buttons: {
          right: [{
            text: 'OK',
            key: 'enter',
            action: function () {
              callback(selectedValue)
              Popup.close()
            }
          },
          {
            text: intl.get('Anuluj'),
            className: 'cancel-button',
            action: function () {
              Popup.close()
            }
          }]
        }
    })
})



// WEBPACK FOOTER //
// ./src/components/Multiselect.js